import React, { useState } from 'react'
import DataTable, { defaultThemes } from 'react-data-table-component'

function TableMedia() {
    
    const customStyles = {

        rows: {
            style: {
                '&:nth-child(odd)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px',
                    
                },
                '&:nth-child(even)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
                '&:nth-child(1)': {
                    backgroundColor: '#F5F8FA',
                    minHeight: '50px'
                },
                '&:nth-child(2)': {
                    backgroundColor: 'white',
                    minHeight: '50px'
                },
            },
        },
        header: {
            style: {
                minHeight: '4px',
                
            },
        },
        headRow: {
            style: {
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                borderTopColor: defaultThemes.default.divider.default,
                backgroundColor:'#18A0FB',
                color:'white',
                height:'50px',
                
            },
        },
        headCells: {
            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        cells: {

            style: {
                '&:not(:last-of-type)': {
                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    borderRightColor: defaultThemes.default.divider.default,
                    

                    // backgroundColor:'red'
                },
            },
        },


        // // when: row => row.year >= 2021,
        // style: {
        // 	backgroundColor: 'rgba(248, 148, 6, 0.9)',
        // 	color: 'white',
        // 	'&:hover': {
        // 		cursor: 'pointer',
        // 	},
        // },
    };

    const columns = [
        {
            name: 'Sl No',
            selector: row => row.slno,
            sortable: true,
            
            
        },
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            
            
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
        },
        {
            name: 'Joined Date',
            selector: row => row.joineddate,
            sortable: true,
        },
       {
            name: 'Action',
            selector: row => row.Action,
            // sortable: true,
        },
    ];
    var data = []
    for (let i = 0; i < 50; i++) {
        const id = i + 1; // Assuming ids start from 1
        const slno = id
        const name = `Name `;
        const email = `admin${id}@gmail.com`;
        const joineddate = `${i < 30 ? 1 + i : -31 + i + 2} - 10 - 2020`; 
        const Action = <a style={{color:'#18A0FB',cursor:'pointer'}}>See More</a>;


        const newObj = { id,slno, name, email, joineddate,Action };
        data.push(newObj);
    }





    return (
        <>
       
        <DataTable
            title="Media List"
            columns={columns}
            data={data}
            customStyles={customStyles}
            pagination
            dense
            highlightOnHover
            selectableRowsHighlight
            // selectableRows
            // progressPending
            // progressComponent={<h1>load</h1>}
    

        />
        </>
    )
}

export default TableMedia